import {combineReducers} from 'redux';
import me from './me';
import maritalStatuses from './maritalStatuses';
import genders from './genders';
import ui from './ui';
import spouse from './spouse';
import address from './address';
import familyMembers from './familyMembers';
import congregations from './congregations';
import serviceTimes from './serviceTimes';
import visit from './visit';
import groups from './groups';
import day from './day';


export default combineReducers({
  me,
  spouse,
  familyMembers,
  address,
  maritalStatuses,
  genders,
  congregations,
  serviceTimes,
  visit,
  groups,
  ui
});



// WEBPACK FOOTER //
// ./src/reducers/index.js